import React, { useState } from 'react';
import './DrugLookup.component.css';

type Itemsprops = {

  NDCCode: string,
  drugName: string,
  doseQty: number,
  doseQtyUnit: string,
};

interface DrugLookupProps {
  items: Itemsprops[];
  handleDrugSelection: (value: any) => void;

}

const DrugLookup: React.FC<DrugLookupProps> = ({ items, handleDrugSelection }) => {
  const [selectedItem, setSelectedItem] = useState<Itemsprops | null>(null);
  const [currentPaginationIndex, setPaginationIndex] = useState<number>(1);
  const handleSelect = (item: Itemsprops) => {
    setSelectedItem(item);
    handleDrugSelection(item);
  };
  const pageSize = 10;
  const totalpages = Math.ceil(items.length / pageSize);

  const getPreviousRecords = () => {
    if (currentPaginationIndex > 1) {
      setPaginationIndex((paginationIndex: number) => paginationIndex - 1);
    }
  };

  const getNextRecords = () => {
    if (currentPaginationIndex < items.length) {
      setPaginationIndex((paginationIndex: number) => paginationIndex + 1);
    }
  };

  const getPaginateRecords = () => {
    const startIndex = (currentPaginationIndex - 1) * 10;
    const endIndex = startIndex + 10;
    return items.slice(startIndex, endIndex);
  };

  return (
    <div
      className="table-full-width table-responsive mb-2"
      data-testid="procedure-div"
    >

      <label className="fw-bold mb-0 mt-3" htmlFor="medication-name">
        Drug Look Up
        {' '}
      </label>
      <table
        className="table fs-sm  rounded sortable-table table-bordered table-hover"
        data-testid="druglookup-table"
        summary="Drug LookUp Table"
      >
        <thead>
          <tr>

            <th scope="col" className="align-top">NDC Code</th>
            <th scope="col" className="align-top">Drug Name</th>
            <th scope="col" className="align-top">Drug Dose</th>
            <th scope="col" className="align-top text-center w-15">Actions</th>
          </tr>
        </thead>
        <tbody>
          {getPaginateRecords().map((item: Itemsprops) => (

            <tr key={item.NDCCode} data-testid="drug-item" className={`${selectedItem?.NDCCode === item.NDCCode ? 'selected-table-row' : ''}`}>

              <td className="" data-testid="procedure-NDCCode">{item.NDCCode}</td>
              <td className="" data-testid="procedure-drugName">{item.drugName}</td>
              <td className="" data-testid="procedure-doseQty">{`${item?.doseQty !== undefined ? item.doseQty : ''} ${item?.doseQtyUnit}`}</td>

              <td>
                <button className={`btn btn btn-primary rounded-pill mr-2 px-4 ${selectedItem?.NDCCode !== item.NDCCode ? 'btnstyle' : ''}`} type="button" data-testid="select" onClick={() => handleSelect(item)}>
                  Select
                </button>
              </td>

            </tr>

          ))}
        </tbody>
      </table>
      <div className="pagination-container all-button-placement">
        <button
          className="button-size btn btn-outline-primary rounded-pill mr-2 px-3"
          type="button"
          onClick={getPreviousRecords}
          hidden={items.length === 0}
          disabled={currentPaginationIndex === 1}
        >
          &lt;
        </button>
        {Array.from({ length: totalpages }, (_, index) => index + 1).map((page) => (
          <button
            key={page}
            className={`button-size btn px-3 ${currentPaginationIndex === page ? 'active' : ''}`}
            type="button"
            onClick={() => setPaginationIndex(page)}
          >
            {page}
            &nbsp;
          </button>
        ))}
        <button
          className="button-size btn btn-outline-primary rounded-pill px-3"
          type="button"
          onClick={getNextRecords}
          hidden={items.length === 0}
          disabled={currentPaginationIndex === totalpages}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default DrugLookup;
